import React, {Component} from 'react';
import VIDABOO_CONSTANTS from '../../config/consts';
import EngageInitiatorComponentRender from './engageInitiatorComponentRender';
import {v4 as uuidv4} from 'uuid';

import {
  ListeningRoomService,
  ShoutingRoomService,
} from '../../services/websocketService';
import AnalyticsService from '../../services/analyticsService';
import PropTypes from 'prop-types';
import ResourcePermissionsService from '../../services/resourcePermissionsService';

const propTypes = {
  currentUser: PropTypes.object,
  sessionMode: PropTypes.string,
  peerUserId: PropTypes.string,
};
const ENGAGER_STATES = {
  INIT: 'INIT',
  SENT_CALL_REQUEST: 'SENT_CALL_REQUEST',
  CALL_REQUEST_RECEIVED_ON_PEER: 'CALL_REQUEST_RECEIVED_ON_PEER',
  PEER_ACCEPTED: 'PEER_ACCEPTED',
  PEER_REJECTED: 'PEER_REJECTED',
};
class EngagerInitiatorComponent extends Component {
  constructor() {
    super();
    this.constraints = {audio: true, video: true};
    this.state = {
      permissionsStatusesObj: {
        [VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA]:
          VIDABOO_CONSTANTS.PERMISSION_STATUS.DENIED,
        [VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]:
          VIDABOO_CONSTANTS.PERMISSION_STATUS.DENIED,
      },
      showPermissionsPopup: false,
    };
    this.deleteDoWhenMessageReceivedFromShoutingRoom = {};
  }

  componentDidMount = () => {
    this.setState({engagerState: ENGAGER_STATES.INIT});

    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER
        ) {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.RESPONSE_TO_INTERACTION_REQUEST
          ) {
            if (
              data.content.message ===
              VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.REJECT
            ) {
              this.rejectCall();
            } else if (
              data.content.message ===
              VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.ACCEPT
            ) {
              this.acceptCall();
            }
          } else if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.ENDPOINT_RCVD_INTERACTION_REQUEST
          ) {
            this.setState({
              engagerState: ENGAGER_STATES.CALL_REQUEST_RECEIVED_ON_PEER,
              peerMsg: JSON.stringify(data),
            });
          }
        }
      });
    if (!VIDABOO_CONSTANTS.NATIVE_APP) {
      this.deletePermissionHandler =
        ResourcePermissionsService.registerHandlePermissionChangeFunc(
          this.handlePermissionChange,
        );
    }
    this.setInitialPermissionsStatuses();
  };
  setInitialPermissionsStatuses = async () => {
    try {
      const permissionsStatusesObj =
        await ResourcePermissionsService.quietGetPermissions([
          VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA,
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE,
        ]);
      this.setState({
        permissionsStatusesObj,
      });
    } catch (error) {
      // if quiet permission not supported
      console.debug('Error: ', error);
    }
  };
  setAutoCallAnswer = (peerUserId) => {
    const engagerReqId = uuidv4();
    this.props.context.setAutoCallAnswerData({
      peerUserId,
      time: new Date().getTime(),
      engagerReqId,
    });
    this.autoCallTimeoutId = setTimeout(() => {
      this.props.context.setAutoCallAnswerData(null);
    }, 40 * 1000);
    return engagerReqId;
  };
  sendInteractionRequest = async () => {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      try {
        const permissionsArr = [
          VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA,
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE,
        ];
        await ResourcePermissionsService.loudGetPermissions(
          permissionsArr,
          true,
        );
        const engagerReqId = this.setAutoCallAnswer(this.props.peerUserId);
        const peerUserId = this.props.peerUserId;
        ListeningRoomService.publishToListeningRoom(
          this.createInteractionReqMessageData(
            this.props.sessionMode,
            engagerReqId,
          ),
          this.props.currentUser.userId,
          peerUserId,
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
        );
        this.sendCallInteractionRequestAnalyticsEvent(peerUserId);
        this.setState({
          engagerState: ENGAGER_STATES.SENT_CALL_REQUEST,
        });
      } catch (error) {
        console.debug('Error: ', error);
      }
    } else {
      try {
        await ResourcePermissionsService.loudGetPermissions(this.constraints);
        const engagerReqId = this.setAutoCallAnswer(this.props.peerUserId);
        this.requestForCall(engagerReqId);
      } catch (error) {
        console.debug('Error: ', error);
        this.setState({
          showPermissionsPopup: true,
        });
      }
      // try {
      //   const permissionsStatusesObj =
      //     await ResourcePermissionsService.quietGetPermissions([
      //       VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA,
      //       VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE,
      //     ]);
      //   this.setState(
      //     {
      //       permissionsStatusesObj,
      //     },
      //     async () => {
      //       if (this.getIsRequiredPermissionsForCallGranted()) {
      //         this.requestForCall(engagerReqId);
      //       } else {
      //         this.setState({
      //           showPermissionsPopup: true,
      //         });
      //         try {
      //           await ResourcePermissionsService.loudGetPermissions(
      //             this.constraints,
      //           );
      //           this.requestForCall();
      //         } catch (error) {
      //           console.debug('Error: ', error);
      //         }
      //       }
      //     },
      //   );
      // } catch (error) {
      //   // if quiet permission not supported
      //   console.debug('Error: ', error);
      //   this.setState({
      //     showPermissionsPopup: true,
      //   });
      //   try {
      //     await ResourcePermissionsService.loudGetPermissions(this.constraints);
      //     this.requestForCall();
      //   } catch (error) {
      //     console.debug('Error: ', error);
      //   }
      // }
    }
  };

  requestForCall = (engagerReqId) => {
    const peerUserId = this.props.peerUserId;
    ListeningRoomService.publishToListeningRoom(
      this.createInteractionReqMessageData(
        this.props.sessionMode,
        engagerReqId,
      ),
      this.props.currentUser.userId,
      peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
    this.sendCallInteractionRequestAnalyticsEvent(peerUserId);
    this.setState({
      showPermissionsPopup: false,
      engagerState: ENGAGER_STATES.SENT_CALL_REQUEST,
    });
  };

  acceptCall = () => {
    this.setState({
      engagerState: ENGAGER_STATES.PEER_ACCEPTED,
    });
    this.clearMsgTimeout = setTimeout(() => {
      this.closePopup();
    }, 5000);
  };
  rejectCall = () => {
    this.setState({
      engagerState: ENGAGER_STATES.PEER_REJECTED,
    });
    this.clearMsgTimeout = setTimeout(() => {
      this.closePopup();
    }, 5000);
  };
  closePopup = () => {
    this.props.closeEngagerRequestPopup();
  };

  showPopup = () => {
    this.popupSeverity = VIDABOO_CONSTANTS.POPUP_SEVERITY.INFO;
    this.popupMessage =
      VIDABOO_CONSTANTS.POPUP_MESSAGES.DAG_FLOW_MESSAGES.PEER_REJECTED;
    this.popupTitle = VIDABOO_CONSTANTS.POPUP_MESSAGES.TITLES.OOOPS;
    this.popupButtons = [
      {
        text: 'Ok',
        funcName: 'closePopup',
      },
    ];
    this.popupFunctions = {
      closePopup: this.closePopup,
    };
    this.showPopupFlag = true;
  };

  sendCallInteractionRequestAnalyticsEvent = (clientUserId) => {
    AnalyticsService.saveConsoltoAnalyticsEvent({
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.ENGAGER,
      action: VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.ENGAGER.CALL_REQUEST,
      mentorId: this.props.mentorId,
      dimensionsMap: {
        peerUserId: clientUserId,
        senderIsMentor: true,
      },
      userId: this.props.currentUser.userId,
      userRole: this.props.currentUser.role,
      senderCreationTime: new Date().getTime(),
      error: false,
    });
  };

  createInteractionReqMessageData = (sessionMode, engagerReqId) => {
    return {
      SubType: VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.INTERACTION_REQUEST,
      //'clientUserId': this.user.userId,
      // senderProfileName: this.props.currentUser.profileName,
      senderObjectId: this.props.mentorId,
      senderUserId: this.props.currentUser.userId,
      senderCreationTime: new Date().getTime(),
      forceStartInPopup: false,
      engagerReqId,
      sessionMode: sessionMode
        ? sessionMode
        : VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO,
    };
  };
  doWhenMessageReceivedFromShoutingRoom = (peerUserId) => {
    this.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId] =
      ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
        peerUserId,
        (messageFromShoutingRoom) => {
          if (
            (messageFromShoutingRoom.senderUserId === 'server' &&
              messageFromShoutingRoom.content.roomId === peerUserId) ||
            messageFromShoutingRoom.senderUserId === peerUserId
          ) {
            if (
              messageFromShoutingRoom.content.availabilityState !==
              VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
            ) {
              // peer disconnected.
            }
          }
        },
      );
  };

  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom();
    Object.keys(this.deleteDoWhenMessageReceivedFromShoutingRoom).forEach(
      (peerUserId) => {
        this.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId]();
      },
    );
    clearTimeout(this.clearMsgTimeout);
    if (this.autoCallTimeoutId) {
      window.clearTimeout(this.autoCallTimeoutId);
    }
    // this.closePopup();
    if (this.deletePermissionHandler) this.deletePermissionHandler();
  };

  handlePermissionChange = (permissionType, permissionStatus) => {
    let permissionsStatusesObj = {...this.state.permissionsStatusesObj};
    permissionsStatusesObj[permissionType] = permissionStatus;
    this.setState({permissionsStatusesObj}, () => {
      if (
        this.getIsRequiredPermissionsForCallGranted() &&
        this.state.showPermissionsPopup
      ) {
        this.setState({
          showPermissionsPopup: false,
        });
      }
    });
  };

  getIsRequiredPermissionsForCallGranted = () => {
    return (
      this.state.permissionsStatusesObj[
        VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
      ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED &&
      this.state.permissionsStatusesObj[
        VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA
      ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
    );
  };

  closePermissionPopup = () => {
    this.setState({showPermissionsPopup: false});
  };

  handlePermissionsSuccess = () => {
    this.setState({
      showPermissionsPopup: false,
    });
  };

  render() {
    return (
      <React.Fragment>
        <EngageInitiatorComponentRender
          parentRef={this}
          permissionsStatusesObj={this.state.permissionsStatusesObj}
          closePopUp={this.closePermissionPopup}
          ENGAGER_STATES={ENGAGER_STATES}
          onPermissionsSuccess={this.closePermissionPopup}
          VIDABOO_CONSTANTS={VIDABOO_CONSTANTS}
        />
      </React.Fragment>
    );
  }
}
EngagerInitiatorComponent.propTypes = propTypes;
export default EngagerInitiatorComponent;
